import { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, ModalV2 as Modal } from '@utilities';

const ModalDeleteQuestionGroup = ({ onClose, onConfirm }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal
      buttons={[
        <Button
          id="modal-delete-question-group-cancel"
          key="cancel-btn"
          onClick={onClose}
          text="Cancel"
          variant="secondary"
        />,
        <Button
          id="modal-delete-question-group-confirm"
          isLoading={isDeleting}
          key="confirm-btn"
          onClick={handleConfirm}
          text="Delete"
          variant="error"
        />,
      ]}
      id="modal-delete-question-group"
      isActive
      onClose={onClose}
      title="Delete question group"
    >
      <p>Are you sure? This will delete all the questions currently in this question group.</p>
    </Modal>
  );
};

ModalDeleteQuestionGroup.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ModalDeleteQuestionGroup;
